'use strict';

import { schema } from './schema.fn';

schema.$inject = ['fieldDefinitionService', 'htmlService', 'dateUtils', '$window', 'configuration'];
angular.module('kerp-forms.forms').factory('LI_FCA_SCHEMA', schema);
